import financialOperationsServices from '@/api/financialOperationsServices';
import { RootState } from '@/app/store';
import { FinancialOperation } from '@/interfaces/financialOperations';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface FinancialOperationsState {
  value: { [key: string]: FinancialOperation[] };
  currFilters: string;
  loading: boolean;
  error: string;
}

const initialState: FinancialOperationsState = {
  value: {},
  currFilters: '',
  loading: false,
  error: '',
};

export const fetchMyTransactions = createAsyncThunk('myTransactions/fetch', async (filters: any, thunkAPI) => {
  try {
    const result = await financialOperationsServices.myTransactions({ ...filters });
    return result;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.data);
  }
});

export const myTransactionsSlice = createSlice({
  name: 'myTransactions',
  initialState,
  reducers: {
    handleParamsChange: (state, action: PayloadAction<{ accountId: string }>) => {
      const filters = JSON.stringify(action.payload);
      state.currFilters = filters;
    },
    refreshTransactions: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchMyTransactions.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchMyTransactions.fulfilled, (state, action) => {
      const { payload: data } = action;
      state.value[state.currFilters] = data.data;
      state.loading = false;
    });
    builder.addCase(fetchMyTransactions.rejected, state => {
      state.loading = false;
      state.error = 'Error';
    });
  },
});

export const { handleParamsChange, refreshTransactions } = myTransactionsSlice.actions;

export const myTransactions = (state: RootState) => state.myTransactions;

export default myTransactionsSlice.reducer;
